module.exports = __webpack_public_path__ + "img/mon_24.3ede8f48.png";